import { FormField } from "@sede-x/shell-ds-react-framework";
import styled from "styled-components";

export const StyledFormField = styled(FormField)`
  margin-bottom: 1.5rem;
`;
